import type { TranslateService } from '@tolgee/ngx';

export type DurationVariant = 'sm' | 'md';

export type DurationTranslations = {
  minutes: string;
  hours: string;
  days: string;
};

const TRANSLATION_KEYS = {
  sm: {
    minutes: 'durations_short_no_value.minutes',
    hours: 'durations_short_no_value.hours',
    days: 'durations_short_no_value.days',
  },
  md: {
    minutes: 'durations_medium_no_value.minutes',
    hours: 'durations_medium_no_value.hours',
    days: 'durations_medium_no_value.days',
  },
} as const;

// Cache for memoization
const translationCache = new Map<string, DurationTranslations>();

export function getDurationTranslations(
  variant: DurationVariant = 'md',
  translate: TranslateService,
): DurationTranslations {
  const cacheKey = `${variant}_${translate.language}`;

  if (translationCache.has(cacheKey)) {
    return translationCache.get(cacheKey)!;
  }

  const translations: DurationTranslations = {
    minutes: translate.instant(TRANSLATION_KEYS[variant].minutes),
    hours: translate.instant(TRANSLATION_KEYS[variant].hours),
    days: translate.instant(TRANSLATION_KEYS[variant].days),
  };

  translationCache.set(cacheKey, translations);
  return translations;
}
